export class CrossRateData {
    constructor() {
        this.Symbol = null;
        this.Exp1 = null;
        this.Exp2 = null;
        this.Price = 0;
        this.IsReverse = null;
        this.Bid = null;
        this.Ask = null;
        this.DefaultPriceType = null;
        this.InstrumentId = null;
        this.InstrumentTypeId = null;
        this.PointSize = null;
        this.SecondCrossRateData = null;
    }
    toString() {
        return this.Exp1 + '/' + this.Exp2 + '=' + this.Price;
    }
}
